const SpriteTypesMapping = Object.freeze({
  0: 'text',
  1: 'image',
});
export default SpriteTypesMapping;